import { render, staticRenderFns } from "./SocialLinks.vue?vue&type=template&id=99551ad0&scoped=true"
import script from "./SocialLinks.vue?vue&type=script&lang=ts"
export * from "./SocialLinks.vue?vue&type=script&lang=ts"
import style0 from "./SocialLinks.vue?vue&type=style&index=0&id=99551ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99551ad0",
  null
  
)

export default component.exports